import * as bowser from 'bowser';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

import { Component, ElementRef, HostBinding, Injector, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { includes, isEmpty } from 'lodash';
import { EventsComponent } from '../events/events.component';
import { Subscription } from 'rxjs';

@Component({
	selector: 'masked-input',
	host: { '[class]': 'myCustomClass' },
	template: `
		<form #maskedInputForm [ngClass]="{ error: error, disabled: control.disabled }">
			<label
				[for]="control.name.split('PolicyData.').join('')"
				[attr.aria-labelledby]="control.attributes.placeholder"
				[attr.aria-describedby]="control.attributes.placeholder"
				class="input-inner-label"
				*ngIf="value"
				><span *ngIf="control.attributes.inputMask.indexOf('*') > -1">&nbsp;&nbsp;</span
				>{{ control.attributes.placeholder }}</label
			>
			<input
				gtm-handler
				[attr.gtm]="gaLabel"
				events="focus"
				handlerType="dataValue"
				[label]="gaLabel"
				action="TextBoxFocus"
				class="masked-input"
				[attr.aria-describedby]="control.name.split('.').join('_') + '_error'"
				[attr.id]="control.name.split('PolicyData.').join('')"
				[(ngModel)]="value"
				[ngClass]="{
					textcolor: value && value.length > 0 && !hideTextColor,
					filled: value,
					empty: !value,
					'has-placeholder': control.attributes.placeholder
				}"
				name="maskedInput"
				[attr.type]="inputType"
				[attr.pattern]="control.attributes.pattern ? control.attributes.pattern : inputPattern"
				[attr.inputmode]="inputMode"
				(focus)="unSelectText($event)"
				(click)="setCarret($event)"
				(touched)="setCarret($event)"
				(ngModelChange)="updateAnswer($event)"
				(blur)="updateAnswer($event, true)"
				[textMask]="maskConfigs()"
				placeholder="{{ control.attributes.placeholder }}"
				[disabled]="control.disabled"
				autocomplete="off"
				(keyup.enter)="keypadClose()"
				(keydown)="onKeyDown($event)"
			/>
			<div *ngIf="error" class="error-container">
				<div class="error">
					<i class="error-icon"></i>
				</div>
			</div>
		</form>
	`,
	styleUrls: ['./masked-input.component.scss'],
})
export class MaskedComponent extends EventsComponent implements OnInit {
	@ViewChild('maskedInputForm', { static: true })
	maskedInputForm;
	el: ElementRef;
	hideTextColor: boolean;
	charsToRemove: any;
	maskOptions: any;
	mask: any;
	inputType = 'text';
	inputPattern: string;
	inputMode: string;
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	readonly dayPrefix: string = '/15/';
	readonly monthAndDayPrefix: string = '1/1/';
	subscriptions: Subscription[] = [];
	globalAttributes: any;

	constructor(injector: Injector, el: ElementRef) {
		super(injector);
		this.el = el;
	}

	async ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.hideTextColor = false;
		this.charsToRemove = this.control.attributes.charsToRemove;
		const bowserType = bowser.getParser(window.navigator.userAgent).getPlatformType();
		this.isMobile = bowserType === 'mobile' || bowserType === 'tablet';
		this.globalAttributes = this.storeService.getGlobalAttributes();
		this.maskOptions = {
			// maskDefinitions: { '9': /[X0-9]/, 'A': /[a-zA-Z]/, '*': /[a-zA-Z0-9]/ },
			allowInvalidValue: true,
			clearOnBlur: false,
			eventsToHandle: ['input', 'keyup', null, 'focus'],
		};

		// this.el.nativeElement.classList.add(`col-${this.control.width}`);
		// this.el.nativeElement.classList.add(`col-${this.control.attributes.class}`);
		const inputControl = this.el.nativeElement.querySelector('.masked-input');
		const allowedChars = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

		if (inputControl) {
			const inputContext = this;
			inputControl.addEventListener('textInput', function (event) {
				const char = event.data;
				const keyCode = char.charCodeAt(0);

				// Prevent from typing invalid characters
				if (!includes(allowedChars, keyCode)) {
					event.preventDefault();
				}

				// Handle masked dates to prevent user to type partial dates
				if (
					inputContext.control.attributes.inputMask === '**/**/9999' &&
					inputContext.value &&
					inputContext.value.indexOf('X') !== -1
				) {
					inputContext.setAnswer('');
					return true;
				}
			});
		}

		if (this.control.attributes) {
			this.inputType = this.control.attributes.inputType || 'text';

			if (this.isMobile && this.control.attributes.DynamicMobileKeyboard) {
				this.inputType = 'text';
				this.inputPattern = '\\d*';
				this.inputMode = 'numeric';
			}
		}
		this.handleDateViewType();
		this.subscriptions.push(this.valueChangeEventEmitter.subscribe(() => this.handleDateViewType()));
	}

	handleDateViewType() {
		if (this.control && this.control.attributes && this.control.attributes.dateView && this.value) {
			const splitValue: string[] = this.value.split('/');
			switch (this.control.attributes.dateView) {
				case 'month':
					splitValue.splice(1, 1);
					this.value = splitValue.join('/');
					break;
				case 'year':
					splitValue.splice(0, 2);
					this.value = splitValue[0];
					break;
			}
		}
	}

	maskConfigs() {
		if (this.control.attributes.inputMask === '99/9999' || this.control.attributes.inputMask === '9999') {
			return { mask: this.getmask(this.control.attributes.inputMask) };
		}
		if (this.control.attributes.inputMask === '99/99/9999' || this.control.attributes.inputMask === '**/**/9999') {
			return { mask: this.getmask(this.control.attributes.inputMask), pipe: createAutoCorrectedDatePipe('mm/dd/yyyy') };
		}
		return {
			mask: this.getmask(this.control.attributes.inputMask),
			placeholderChar: this.setPlaceholderChar(),
			guide: true,
		};
	}

	getmask(inputmask) {
		switch (this.control.attributes.inputMask) {
			case '(999)-999-9999':
				return ['(', /\d/, /\d/, /\d/, ')', '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
			case '**/**/9999':
				return [/[X0-9]/, /[X0-9]/, '/', /[X0-9]/, /[X0-9]/, '/', /\d/, /\d/, /\d/, /\d/];
			case '***-**-9999':
				return [/[X0-9]/, /[X0-9]/, /[X0-9]/, '-', /[X0-9]/, /[X0-9]/, '-', /[X0-9]/, /[X0-9]/, /[X0-9]/, /[X0-9]/];
			case '99/99/9999':
				return [/[X0-9]/, /[X0-9]/, '/', /[X0-9]/, /[X0-9]/, '/', /\d/, /\d/, /\d/, /\d/];
			case '99/9999':
				return [/[X0-9]/, /\d/, '/', /[X0-9]/, /\d/, /\d/, /\d/];
			case '9999':
				return [/[X0-9]/, /\d/, /\d/, /\d/];
			default:
				return this.control.attributes.inputMask;
		}
	}

	setPlaceholderChar() {
		switch (this.control.attributes.inputMask) {
			case '(999)-999-9999':
			case '***-**-9999':
				return 'X';
			case '**/**/9999':
			case '99/99/9999':
				return '*';
			default:
				return 'X';
		}
	}

	updateAnswer(event, blur: boolean = false) {
		if (
			this.control.attributes.inputMask === '***-**-9999' &&
			this.globalAttributes &&
			this.globalAttributes['hqx-ssn-masking'] &&
			event &&
			blur &&
			typeof this.value === 'string' &&
			!this.value.includes('X') &&
			this.value.length === 11
		) {
			const request = Object.assign(
				{},
				{
					data: { ...this.storeService.getAnswers(this.context), [this.control.name]: this.value },
					info: { action: 'Relevancy', stage: null, elementSrc: null, conditions: null, notRenderPage: null },
				}
			);
			this.actionService.invokeAction(request, true).then(
				function (response) {
					this.maskSSNValue();
				}.bind(this)
			);
			this.maskSSNValue();
		}
		// clean special characters if corresponding key exist
		let strippedValue = this.stripChars(this.value, this.charsToRemove).trim();
		this.hideTextColor = this.value === this.control.attributes.placeholder;
		// empty value if view value same as placeholder
		// if (this.hideTextColor) {
		//     strippedValue = '';
		// }
		this.reportEditedPrefillValue();

		//format date value if view type is month or year
		if (this.control.attributes && this.control.attributes.dateView) {
			switch (this.control.attributes.dateView) {
				case 'month':
					let tempValue: string[] = strippedValue.split('/');
					tempValue.splice(1, 0, this.dayPrefix);
					strippedValue = tempValue.join('');
					break;
				case 'year':
					strippedValue = this.monthAndDayPrefix.concat(strippedValue);
					break;
			}
		}
		return this.setAnswer(strippedValue);
	}

	private maskSSNValue() {
		setTimeout(() => {
			this.value = 'XXX-XX-' + this.value.slice(-4);
		}, 100);
	}

	stripChars(value, charsToRemove) {
		if (typeof value === 'undefined' || value === null) {
			return '';
		}

		return !isEmpty(this.charsToRemove)
			? value
					.split('')
					.filter((char) => charsToRemove.indexOf(char) === -1)
					.join('')
			: value;
	}

	unSelectText($event) {
		const label = this.control.title ? this.control.title : this.control.attributes.labelForSplunk;
		this.splunkAnalyticsService.publish('TextBoxFocus', label || '', '');

		let rangeSelection;
		if (document.getSelection().rangeCount === 0 && rangeSelection !== undefined) {
			if (typeof rangeSelection.empty === 'function') {
				rangeSelection.empty();
			}
		} else {
			if (window.getSelection) {
				window.getSelection().removeAllRanges();
			}
			const activeElement = document.activeElement;
			if (activeElement) {
				const tagName = activeElement.nodeName.toLowerCase();
				if (
					tagName === 'textarea' ||
					(tagName === 'input' && activeElement.getAttribute('type') === 'text') ||
					(tagName === 'input' && activeElement.getAttribute('type') === 'tel')
				) {
					(activeElement as HTMLInputElement).selectionStart = (activeElement as HTMLInputElement).selectionEnd;
				}
			}
		}
	}

	setCarret($event) {
		let caretPos = 0;
		const elem = $event.currentTarget;
		const currentPosition = this.getCaretPosition(elem);
		const allowedChars = ['-', '(', ')', '/', ':'];

		// Not first position, calculate caret position
		if (currentPosition > 0 && this.value) {
			let valueChars = [];
			let maskChars = [];
			const splitValue = this.value.substring(0, currentPosition);

			// Have value and have placeholder in string from begin to caret position
			if (this.value && splitValue && splitValue.length > 0 && this.isPlaceholderExists(splitValue)) {
				valueChars = this.value.split('');
				maskChars = this.control.attributes.placeholder.split('');

				// Calculate end of string for caret jump
				for (let i = 0; i <= maskChars.length; i++) {
					if (!includes(allowedChars, valueChars[i]) && (valueChars[i] === maskChars[i] || valueChars[i] === '_')) {
						caretPos = i;
						break;
					}
				}
			} else if (!splitValue || splitValue.length === 0) {
				caretPos = 0;
			} else {
				caretPos = currentPosition;
			}
		}

		if (elem != null) {
			if (elem.createTextRange) {
				const range = elem.createTextRange();
				range.move('character', caretPos);
				range.select();
			} else {
				if (elem.selectionStart) {
					elem.focus();
					elem.setSelectionRange(caretPos, caretPos);
				} else {
					elem.focus();
				}
			}
		}
		if (this.control.attributes.inputMask === '99/99/9999' || this.control.attributes.inputMask === '**/**/9999') {
		}
	}

	isPlaceholderExists(value) {
		const placeholderChars = ['X', 'M', 'D', 'Y', '_'];
		let result = false;

		// If have value then check
		if (value && value.length > 0) {
			placeholderChars.forEach((character) => {
				if (value.indexOf(character) !== -1) {
					result = true;
					return;
				}
			});
		} else {
			result = true;
		}

		return result;
	}

	getCaretPosition(elem) {
		let caretPos = 0;

		// if (document.getSelection()) {
		//     elem.focus();
		//     let selection = document.createRange();
		//     // selection.setStart('character', -elem.value.length);
		//     // caretPos = selection.text.length; //todo
		// }
		// else
		if (elem.selectionStart || elem.selectionStart === '0') {
			caretPos = elem.selectionStart;
		}

		return caretPos;
	}

	onKeyDown(event) {
		if (this.control.attributes.inputMask === '**/**/9999' && this.value && this.value.indexOf('X') !== -1) {
			this.value = '';
		}

		// detect Ctrl+z key combination and (if detected) clear the input field
		if (event.keyCode === 90 && event.ctrlKey === true) {
			this.value = '';
		}
	}

	keypadClose() {
		this.isMobile && this.el.nativeElement.querySelector('.masked-input').blur();
	}

	mouseOver(e: any) {
		const label = this.control.title ? this.control.title : this.control.attributes.labelForSplunk;
		this.splunkAnalyticsService.publish('Hover', label || '', '0');
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
	}
}
